// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"14a9a607b580d0916ea6","293":"86748980ce32911f5197"}[chunkId] + ".js";
};